import { render, staticRenderFns } from "./XingbiaoButton.vue?vue&type=template&id=62bb5571&scoped=true&"
import script from "./XingbiaoButton.vue?vue&type=script&lang=js&"
export * from "./XingbiaoButton.vue?vue&type=script&lang=js&"
import style0 from "./XingbiaoButton.vue?vue&type=style&index=0&id=62bb5571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bb5571",
  null
  
)

export default component.exports